import {Component, OnInit} from '@angular/core';
import { API, FORMS } from '../../../_config/strings';
import { CLIENTE } from '../../../_model/ClienteJson';
import { NetworkHelperService } from '../../../_services/network-helper.service';
import { Usuario } from '../../../_model/Usuario';
import swal from 'sweetalert2';
import { ChatService } from '../../../_services/chat.service';
import { Router } from '@angular/router';
declare var $: any;
@Component({
   selector: 'app-crear-cliente',
   templateUrl: './crear-cliente.component.html',
   styleUrls: ['./crear-cliente.component.scss']
})

export class CrearClienteComponent implements OnInit {
    FORMS: any;
    API:any;public usuario: Usuario = new Usuario();
    cliente: any;
    tablaDeContactos = [];
    nombreContacto = '';
    puestoContacto = '';
    correoContacto = '';
    telContacto = 0;
    celContacto = 0;
    btnGuardar:boolean = false;
    pito;
    deshabilitarCampos;
    deshabilitarRS;
    constructor(
        private network: NetworkHelperService,
        private chat: ChatService,
        private router: Router
    ){
        this.FORMS = FORMS;
        this.API = API; 
        this.cliente = CLIENTE;
        this.usuario = JSON.parse( localStorage.getItem('usuario') );
    }
    ngOnInit() {
    }

    tipoCliente(tipo, id){
        //inicializamos el div del segundo paso
        document.getElementById("infoBasicaId").hidden = false;
        switch(id)
        {
            case 1:{
                //fisica
                this.FORMS.crearCliente.nombre.titulo = 'Nombre';
                this.FORMS.crearCliente.paterno.titulo = 'Apellido Paterno';
                this.FORMS.crearCliente.materno.titulo = 'Apellido Materno';
                this.FORMS.crearCliente.domicilioCliente = 'Domicilio Particular';
                this.FORMS.crearCliente.ine.titulo = 'Identificacion Oficial (Vigente)';
                document.getElementById('razonSocialText').hidden = true;
                document.getElementById('SAT').hidden = true;
                document.getElementById('ACTA').hidden = true;
                document.getElementById('PODER').hidden = true;
                break;
            }
            case 2:{
                this.FORMS.crearCliente.nombre.titulo = 'Representante Legal (Nombre)';
                this.FORMS.crearCliente.paterno.titulo = 'Representante Legal (Apellido Paterno)';
                this.FORMS.crearCliente.materno.titulo = 'Representante Legal (Apellido Materno)';
                this.FORMS.crearCliente.domicilioCliente = 'Domicilio Fiscal';
                this.FORMS.crearCliente.ine.titulo = 'Identificacion Oficial del Representate Legal (Vigente)';
                document.getElementById('razonSocialText').hidden = false;
                document.getElementById('SAT').hidden = false;
                document.getElementById('ACTA').hidden = false;
                document.getElementById('PODER').hidden = false;
                //moral
                break;
            }
            case 3:{
                //especial
                this.FORMS.crearCliente.nombre.titulo = 'Nombre (Particular o Representante Legal)';
                this.FORMS.crearCliente.paterno.titulo = 'Apellido Paterno (Particular o Representante legal)';
                this.FORMS.crearCliente.materno.titulo = 'Apellido Materno (Particular o Representante legal)';
                this.FORMS.crearCliente.domicilioCliente = 'Domicilio Fiscal o Particular';
                this.FORMS.crearCliente.ine.titulo = 'Identificacion Oficial del Particular o Representante (Vigente)';
                document.getElementById('razonSocialText').hidden = false;
                
                document.getElementById('SAT').hidden = false;
                document.getElementById('ACTA').hidden = false;
                document.getElementById('PODER').hidden = false;
                break;
            }
            case 4:{
                //cuantiaMenor
                this.FORMS.crearCliente.nombre.titulo = 'Nombre (Particular o Representante Legal)';
                this.FORMS.crearCliente.paterno.titulo = 'Apellido Paterno (Particular o Representante legal)';
                this.FORMS.crearCliente.materno.titulo = 'Apellido Materno (Particular o Representante legal)';
                this.FORMS.crearCliente.domicilioCliente = 'Domicilio Fiscal o Particular';
                this.FORMS.crearCliente.ine.titulo = 'Identificacion Oficial del Particular o Representante (Vigente)';
                document.getElementById('razonSocialText').hidden = false;
                
                document.getElementById('SAT').hidden = false;
                document.getElementById('ACTA').hidden = false;
                document.getElementById('PODER').hidden = false;
                break;
            }
        }
        
        this.cliente.tipoCliente = id;
    }

    armadoContactos() {
        this.tablaDeContactos.push({
            nombre: this.nombreContacto,
            correo: this.correoContacto,
            telefono: this.telContacto,
            celular: this.celContacto,
            puesto: this.puestoContacto

        });
        this.nombreContacto = '';
       this.puestoContacto = '';
       this.correoContacto = '';
       this.telContacto = 0;
       this.celContacto = 0;
       this.cliente.contactos = this.tablaDeContactos;
       document.getElementById("documentacion").hidden = false;
    }

    eliminarContacto(contactoNombre) {
        const contactoBuscadoPorNombre = this.tablaDeContactos.findIndex( productoEncontrado => productoEncontrado.contactoNombre === contactoNombre );
        this.tablaDeContactos.splice(contactoBuscadoPorNombre, 1);
        // Máximo son 4 contactos al llegar a un quinto el botón desaparece.
        // El siguiente IF volverá a mostrar el botón para que el usuario siga agregando (sólo 4 contactos)
        if (this.tablaDeContactos.length === 4) {
            document.getElementById('divboton').style.opacity = '0';
        } else {
            document.getElementById('divboton').style.opacity = '1';
            //this.deshabilitarBoton = false;
        }
    }
    
    documentacion()
    {
        document.getElementById("documentacion").hidden = false;
    }
    generarDocumentos()
    {

    }

    guardarCliente()
    {
    
        const jsonObjet = {
            nuevoCliente: this.cliente 
        }
        this.network.callSecureService(
            this.API.user.clientes +'/'+ this.API.user.crear,
            'POST',
            jsonObjet
        ).subscribe((response:any) => {
                console.log(response);
                if(response.Estatus == 201)
                {
                this.subidaDeArchivos(response.Mensaje.cliente);
                
                for(let chat of response.Mensaje.notificacion)
                {
                this.chat.sendMsg({
                    mensaje: 'El usuario '+this.usuario.userName+' ha registrado un nuevo cliente',
                    usuario: this.usuario.userName,
                    target: chat.target,
                    tipo: 'notificacion',
                    url: 'verCliente/' + response.Mensaje.cliente,
                    id: chat.id
                });
            }

                } else {
                    swal('Cliente Existente', response.Mensaje, 'error');
                }
        }, err => {
            console.log(err)
        });

    }

    cambiosEninputs(){
        //console.log('Cambios en input');
        this.btnGuardar = true;
    }
    controlInputs(){
        document.getElementById('rfcDocument').classList.remove("bordeRojo");
    }

    excepciones(){
        //las excepciones e spor ejemplo en control del RFC no esta lleno
        if(!this.cliente.rfc)
        {
            swal('Falta RFC', "El campo RFC esta vacio o incompleto", 'warning');
            document.scrollingElement.scrollTop = document.getElementById('rfcColum').scrollHeight;
            document.getElementById('rfcDocument').classList.add("bordeRojo");
            return swal('Falta RFC', "El campo RFC esta vacio o incompleto", 'warning');
        }
        this.guardarCliente();
    }

    subidaDeArchivos(clienteId)
    {
        const formDataArchivos: FormData = new FormData();
        formDataArchivos.append('clienteId', clienteId);
        let archivos = $('.archivoDocumento');
        for(const archivo of archivos)
        {
            if(archivo.files.length > 0)
            {
            formDataArchivos.append(archivo.id, archivo.files[0]);
            }
        }
        
        this.network.callSecureService(
            this.API.user.clientes +'/'+ this.API.user.archivos + '/' + this.API.user.subir,
            'POST',
            formDataArchivos
        ).subscribe((response:any) => {
                console.log(response);
                this.router.navigate(['dashboard/verCliente', clienteId]);
                swal('Cliente Registrado', 'Se registro correctamente el cliente', 'success');
        }, err => {
            console.log(err);
            swal('Error con la Documentación', 'Vuelve a subir tus documentos, si el problema persiste llama a Soporte/Desarrollo', 'error');
            this.router.navigate(['/dashboard/verCliente', clienteId]);
        });
    }
}


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/cliente/crear-cliente/crear-cliente.component.ts